import { Result } from "./Result";

type ResultContainereProps = {
	id: string;
}


const ResultContainer = (props: ResultContainereProps) => {

	return (
		<>
			<Result id={props.id} />
		</>
	);
};

export { ResultContainer };
